/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'heart2': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M17.5 1c-1.694 0-3.319.65-4.575 1.834A6.656 6.656 0 0 0 12 3.915a6.706 6.706 0 0 0-.925-1.081A6.654 6.654 0 0 0 6.5 1 6.508 6.508 0 0 0 0 7.5c0 2.172.625 4.344 1.856 6.456.963 1.65 2.297 3.269 3.969 4.806 2.816 2.594 5.597 4.062 5.712 4.125a.99.99 0 0 0 .932 0c.116-.063 2.9-1.531 5.712-4.125 1.669-1.538 3.006-3.156 3.969-4.806C23.375 11.844 24 9.672 24 7.5 24 3.916 21.084 1 17.5 1zm-.644 16.259A29.11 29.11 0 0 1 12 20.853C9.972 19.665 2 14.553 2 7.5 2 5.019 4.019 3 6.5 3c1.181 0 2.319.459 3.203 1.291C10.528 5.066 11 6.053 11 7h2c0-.947.472-1.934 1.297-2.709A4.673 4.673 0 0 1 17.5 3C19.981 3 22 5.019 22 7.5c0 4.137-2.797 7.591-5.144 9.759z"/>`
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/heart2.js